"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _date = require("@/utils/date");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var customer = _interopRequireWildcard(require("@/api/customer"));
var _CustomerDialog = _interopRequireDefault(require("./components/CustomerDialog"));
var _format = require("@/utils/format");
var _vuex = require("vuex");
var _excel = require("./excel");
var _ExportCustomerModal = _interopRequireDefault(require("./components/ExportCustomerModal.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    CustomerDialog: _CustomerDialog.default,
    ExportCustomerModal: _ExportCustomerModal.default
  },
  data: function data() {
    return {
      listLoading: false,
      total: 0,
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      enumSex: {
        MALE: "Nam",
        FEMALE: "Nữ"
      },
      listQuery: {
        page: 1,
        limit: 10,
        search: "",
        isBlock: null
      },
      tableData: [],
      loadingExcel: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  created: function created() {
    this.getTableData();
    this.$store.dispatch("area/fetchList");
  },
  methods: {
    handleReset: function handleReset(row) {
      var _this = this;
      this.$prompt("Nhập mật khẩu mới để khôi phục", "Khôi phục mật khẩu", {
        confirmButtonText: "OK",
        cancelButtonText: "Hủy"
      }).then(function (_ref) {
        var value = _ref.value;
        var data = {
          password: value
        };
        _this.listLoading = true;
        customer.resetPassword(row.id, data).then(function (res) {
          _this.$notify({
            type: "success",
            message: "Khôi phục mật khẩu thành công"
          });
        }).finally(function () {
          _this.listLoading = false;
        });
      });
    },
    formatCurrency: function formatCurrency(n) {
      return (0, _format.formatCurrency)(n);
    },
    handleEdit: function handleEdit(row) {
      this.$refs["dialog"].handleEdit(row);
    },
    handleAdd: function handleAdd() {
      this.$refs["dialog"].handleAdd();
    },
    handleImgError: function handleImgError(event) {
      event.currentTarget.src = require("@/assets/images/avatar_default.svg");
    },
    handleUnBlock: function handleUnBlock(row) {
      var _this2 = this;
      this.$confirm("Khách hàng này sẽ được mở khóa, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        var data = {
          customer: {
            isBlock: false
          }
        };
        customer.update(row.id, data).then(function () {
          row.isBlock = false;
          _this2.$message({
            type: "success",
            message: "Mở khóa khách hàng thành công"
          });
        });
      });
    },
    handleBlock: function handleBlock(row) {
      var _this3 = this;
      this.$confirm("Khách hàng này sẽ bị khóa, bạn có muốn tiếp tục?", "Cảnh báo", {
        confirmButtonText: "OK",
        cancelButtonText: "Đóng",
        type: "warning"
      }).then(function () {
        var data = {
          customer: {
            isBlock: true
          }
        };
        customer.update(row.id, data).then(function () {
          row.isBlock = true;
          _this3.$message({
            type: "success",
            message: "Khóa khách hàng thành công"
          });
        });
      });
    },
    getTableData: function getTableData() {
      var _this4 = this;
      this.listLoading = true;
      customer.findAll(this.listQuery).then(function (res) {
        _this4.tableData = res.data.data;
        _this4.total = res.data.total;
      }).finally(function () {
        _this4.listLoading = false;
      });
    },
    formatDateTime: function formatDateTime(timestamp) {
      return (0, _date.formatDateTime)(timestamp);
    },
    confirmExport: function confirmExport() {
      this.$refs["export-customer-modal"].handleOpen(this.listQuery.page, this.listQuery.limit);
    },
    handleExportExcel: function () {
      var _handleExportExcel = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(page, limit) {
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
                page: page,
                limit: limit
              });
              this.loadingExcel = true;
              _context.prev = 2;
              _context.next = 5;
              return customer.findAll(query);
            case 5:
              res = _context.sent;
              if (res.data.data.length > 0) {
                (0, _excel.exportCustomerExcel)({
                  customers: res.data.data
                });
                this.$message({
                  message: "\u0110\xE3 xu\u1EA5t ".concat(res.data.data.length, " kh\xE1ch h\xE0ng"),
                  type: "success"
                });
              } else {
                this.$message({
                  message: "Kh\xF4ng t\xECm th\u1EA5y kh\xE1ch h\xE0ng n\xE0o, Vui l\xF2ng ki\u1EC3m tra l\u1EA1i. (Trang: ".concat(page, ", S\u1ED1 b\u1EA3n ghi: ").concat(limit, ")"),
                  type: "error"
                });
              }
            case 7:
              _context.prev = 7;
              this.loadingExcel = false;
              return _context.finish(7);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2,, 7, 10]]);
      }));
      function handleExportExcel(_x, _x2) {
        return _handleExportExcel.apply(this, arguments);
      }
      return handleExportExcel;
    }()
  }
};